import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { styled, Typography } from "@mui/material";
import Button from "components/Buttons/ThemeButton";
import CloseIconButton from "../lib/CloseIconButton";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
//import { useEnvContext } from "contexts/EnvProvider";
import { CustomDialog } from "./styles";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { IPlaygamiAnalyticProps } from "interfaces/analytics/playgami";
import { useEffect } from "react";
import backgroundImage from "assets/loyalty-points/background-success.png";

const buttonStyles = {
	paddingTop: ".75rem",
	paddingBottom: ".75rem",
	marginBottom: 1,
	width: "calc(100% - 3rem)",
	marginLeft: 2,
	marginRight: 2
};

const ButtonContainer = styled("div")({
	width: "100%",
	paddingLeft: "16px"
});

const DialogLoyaltyPurchaseSuccess = ({
	show,
	onCloseClick
}: {
	show: boolean;
	onCloseClick: () => void;
}) => {
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	//const { cdnPrefix } = useEnvContext();
	//const backgroundImage = `url(${cdnPrefix}/spec_dialogs/success.png)`;
	const scale = useCalculateScale(370 + 40, 390 + 40);

	const reportAnalytics = ({ event_name }: IPlaygamiAnalyticProps) => {
		const event_type = "loyalty_purchase_success_dialog";
		reportPlaygamiEvent("tp.web_frontend", {
			event_name,
			event_type,
			action: event_name,
			source: event_type
		});
	};

	const onClick = () => {
		reportAnalytics({
			event_name: "continue_shopping_click"
		});
		onCloseClick?.();
	};

	const onClose = () => {
		reportAnalytics({
			event_name: "dialog_x_closed"
		});
		onCloseClick?.();
	};

	useEffect(() => {
		if (show) {
			reportAnalytics({ event_name: "dialog_shown" });
		}
	}, [show]);

	return (
		<CustomDialog open={show} onClose={onClose} scale={scale}>
			<DialogTitle
				sx={{
					height: "188px",
					padding: 0,
					backgroundSize: "cover",
					backgroundColor: "#3B2FC5",
					backgroundImage: `url(${backgroundImage})`,
					backgroundPosition: "center",
					overflow: "hidden"
				}}
			>
				<CloseIconButton onClose={onClose} />
			</DialogTitle>
			<DialogContent sx={{ paddingBottom: 0 }}>
				<DialogContentText sx={{ padding: ".5rem 1rem" }}>
					<Typography
						variant="h6"
						component="strong"
						sx={{
							margin: "0.5rem 0 .5rem",
							display: "block",
							textAlign: "center",
							fontSize: "24px",
							lineHeight: 1,
							color: "#333",
							fontFamily: "Baloo",
							fontWeight: "400"
						}}
					>
						Thanks for your purchase!
					</Typography>
					<Typography
						sx={{ margin: "0px", textAlign: "center", color: "#000" }}
					>
						Your purchase has been completed. Your items are waiting in your
						in-game inbox to be collected.
					</Typography>
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ justifyContent: "center", flexDirection: "column" }}>
				<ButtonContainer>
					<Button
						onClick={onClick}
						themeColor="secondary"
						sx={{
							...buttonStyles
						}}
					>
						Continue Shopping
					</Button>
					{/* {isMobile ? (
						<BackToGameButton
							source={"loyalty_purchase_success_dialog"}
							themeColor="secondary"
							sx={{
								...buttonStyles,
								backgroundColor: "#4088B7",
								"&:hover": {
									backgroundColor: "#25506d"
								}
							}}
						/>
					) : null} */}
				</ButtonContainer>
			</DialogActions>
		</CustomDialog>
	);
};

export { DialogLoyaltyPurchaseSuccess };
